import FormConfig from "../formConfig.js";
import { fun_PostAction, fun_GetAction } from "@/api/index";
import { Loading } from "element-ui";
import CaLock from "@/components/common/calock";
import BiddingAgencyDialog from "../../../components/biddingAgencyDialog/index.vue";
import BiddingProjectDialog from "../../../components/biddingProjectDialog/index.vue";
export default {
  data() {
    return {
      // 判断是否从工作台进入
      workbenchMenu: null,
      // 工作台状态
      workbenchState: true,
      // 表单配置
      formConfigList: FormConfig.configList(),
      // 表单绑定值
      form: {
        prjbuildCorpName: null, // 企业名称
        buildCorpNameCode: null, // 社会信用代码
        constructionNo: null, // 报建编号
        constructionId: null, // 报建信息表主键
        prjName: null, // 项目名称
        agencyCorpName: null, // 招标代理机构名称
        agencyCorpCode: null, // 招标代理机构社会信用代码
        agencyCorpLegalPerson: null, // 代理机构法人姓名
        agencyMark: null, // 代理内容
        lockNo: null, // 锁编号
        digitalSignature: null // 数字签名
      },
      // 全局加载
      fullLoading: null,
      // 主键
      id: this.$route.query.id,
      // 操作类型
      controllerFlg: this.$route.query.controllerFlg,
      // 用于判断状态图片
      flagState: null
    };
  },

  // 注册组件
  components: {
    CaLock,
    BiddingAgencyDialog,
    BiddingProjectDialog
  },
  // 模板编译前
  created() {
    // 获取数据
    this.workbenchMenu = sessionStorage.getItem("workbenchMenu")
      ? sessionStorage.getItem("workbenchMenu")
      : null;
  },
  // 模板编译完成
  mounted() {
    // 操作类型为查看详情
    if (this.controllerFlg == "detail") {
      // 遍历
      this.formConfigList.map((value, index) => {
        // 遍历标签页内表单
        value.formConfigList.map(form => {
          // 置灰
          form.disabled = true;
        });
      });
    }
    // 获取详情
    this.fun_Details();
  },
  // 自定义方法
  methods: {
    /**
     * 获取CA办理资料详情
     * @author shuhua
     */
    fun_Details() {
      // 发起请求
      fun_GetAction("/agencyCorpRecords/detail", {
        id: this.id
      }).then(res => {
        // 结构res.data
        const { result, data, msg } = res.data;
        // 请求成功
        if (result) {
          // 表格数据
          this.form = data.model;
          // 获取状态用于判断显示图片
          this.flagState = data.model.state;
          // 工作台状态
          this.workbenchState = data.workbenchState;
        } else {
          // 提示请求失败的信息
          this.$message.error(msg);
        }
      });
    },
    /**
     * 确定的方法
     * @author shuhua
     */
    fun_Submit() {
      // 表单验证
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        // 验证通过
        if (valid) {
          // 开启弹窗
          this.$refs.caLock.dialogCalock = true;
          // 签名数据, 交易人名称和日期
          this.$refs.caLock.data =
            this.form.prjbuildCorpName +
            this.form.buildCorpNameCode +
            this.form.agencyCorpName +
            this.form.agencyCorpCode;
          // 状态
          this.$refs.caLock.state = "tj";
        } else {
          return false;
        }
      });
    },
    /**
     * 保存或修改的方法
     * @author shuhua
     */
    fun_SaveOrUpdate(state, lockNo, digitalSignature) {
      // ca弹窗关闭
      this.$refs.caLock.dialogCalock = false;
      // 赋值锁编号
      this.form.lockNo = lockNo;
      // 赋值数字签名
      this.form.digitalSignature = digitalSignature;
      // 打开遮罩
      this.fun_Loading();
      // 发起请求
      fun_PostAction("agencyCorpRecords/saveOrUpdate", {
        ...this.form
      }).then(res => {
        // 解构res.data
        const { result, msg } = res.data;
        // 操作成功
        if (result) {
          // 加载框取消
          this.fullLoading.close();
          // 操作成功
          this.$message.success(msg);
          // 返回一览
          this.$router.back();
        } else {
          // 加载框取消
          this.fullLoading.close();
          // 错误消息提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 打开招标项目选择弹窗
     * @author shuhua
     */
    fun_OpenProjectDialog() {
      // 打开弹窗
      this.$refs.biddingProjectDialog.dialogVisible = true;
      // 请求接口
      this.$refs.biddingProjectDialog.fun_GetList();
    },
    /**
     * 打开代理机构选择弹窗
     * @author shuhua
     */
    fun_OpenAgencyDialog() {
      // 打开弹窗
      this.$refs.biddingAgencyDialog.dialogVisible = true;
      // 请求接口
      this.$refs.biddingAgencyDialog.fun_GetList();
    },
    /**
     * 清空
     * @author shuhua
     */
    fun_Clean(e) {
      // 招标项目信息清空
      if (e === "0") {
        // 清空报建编号
        this.form.constructionNo = null;
        // 清空项目名称
        this.form.prjName = null;
      } else {
        // 清空招标代理机构名称
        this.form.agencyCorpName = null;
        // 招标代理机构社会信用代码
        this.form.agencyCorpCode = null;
        // 代理机构法人姓名
        this.form.agencyCorpLegalPerson = null;
      }
    },
    /**
     * 全局加载
     * @author zhouzhou
     */
    fun_Loading() {
      this.fullLoading = Loading.service({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 返回
      this.$router.back();
    }
  }
};
